export default "__VITE_ASSET__B70LU_qr__"